/**
 * Created by fers on 22/11/16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, IntlShape} from 'react-intl';
import {getEditDataSourceFragment} from './../box-utils/ScreenDisplayer.react';
import {assert} from 'chai';
import handlers from '../datasource-handlers/handlers';
import DataSourceManualQueryEdit from '../datasource-handlers/DataSourceManualQueryEdit.react';
import DataSourceSearchActionEdit from '../datasource-handlers/DataSourceSearchActionEdit.react';
import DataSourceCompanySearchEdit from '../datasource-handlers/DataSourceCompanySearchEdit.react';

class DataSourcesToEdit extends React.Component {
    static propTypes = {
        dataSource: PropTypes.object.isRequired,
        dataSourceList: PropTypes.object,
        intl: PropTypes.object,
        screen: PropTypes.object.isRequired,
        screenSettings: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
    }

    render() {
        let dataSource = this.props.dataSource;
        assert.isDefined(dataSource);

        let uiAddHandler = handlers[dataSource.typeId].configHandler;
        return React.createElement(uiAddHandler, {
            dataSource: this.props.dataSource,
            apply: (dataSource) => {
                return this.props.screenSettings.updateDataSource(dataSource).then(() => {
                    this.props.dataSourceList.goBack();
                });
            },
            goBack: () => {
                return this.props.dataSourceList.goBack();
            }
        });
    }
}

export default Relay.createContainer(injectIntl(DataSourcesToEdit), {
    initialVariables: {
    },
    prepareVariables (variables) {
        return variables;
    },
    fragments: {
        dataSource: () => {
            return Relay.QL`
                fragment on DataSource {
                    id,
                    realId,
                    typeId,
                    ${getEditDataSourceFragment()},
                    ${DataSourceSearchActionEdit.getFragment('dataSource')}
                    ${DataSourceCompanySearchEdit.getFragment('dataSource')}
                    ${DataSourceManualQueryEdit.getFragment('dataSource')},
                }`;
        }
    }
});
